import React from 'react'
import styled from 'styled-components'

import ampmeLogo from '../../assets/images/ampme-small-logo.png'

import Image from '../shared/image'
import Link from '../shared/link'

const Main = styled.div`
  height: 100%;
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
`

const Logo = styled(Image).attrs({
  src: ampmeLogo
})`
  height: 100px;
  width: 100px;
  margin: 15px auto;
`

const Title = styled.div`
  margin: 0 auto;
  font-size: 18px;
  font-weight: 600;
`

const Version = styled.div`
  margin: 5px auto;
  font-size: 14px;
`

const SubTitle = styled.div`
  margin: 0 auto;
`

const Copyright = styled.div`
  font-size: 12px;
  color: #8c8a8a;
  margin: 0 auto;
`

const Links = styled.div`
  display:flex;
  margin: 0 auto;
`

const Licenses = styled(Link).attrs({
  url: 'https://ampme.com/opensources'
})``

const Terms = styled(Link).attrs({
  url: 'https://ampme.com/terms'
})``

const LinkText = styled.div`
  font-size: 12px;
  margin: 5px;
`

export const About = () => {
  return (
    <Main>
      <Logo />
      <Title>
        AmpMe Desktop
      </Title>
      <SubTitle>
        Play Music Louder
      </SubTitle>
      <Version>
        Version {process.env.REACT_APP_VERSION}
      </Version>
      <Links>
        <Licenses>
          <LinkText>
            Licenses
          </LinkText>
        </Licenses>
        <Terms>
          <LinkText>
            Terms & Conditions
          </LinkText>
        </Terms>
      </Links>
      <Copyright>
        ©2019 Amp Me Inc.
      </Copyright>
    </Main>
  )
}



// WEBPACK FOOTER //
// ./src/components/about/about.js